import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantPrinterDto } from './merchantPrinter.dto';
import { OrderStatusDto } from './orderStatus.dto';
export class MerchantOrderStatusPrinterDto extends BaseDto{
  noCopies: number;
  merchant: MerchantDto;
  merchantPrinter: MerchantPrinterDto;
  orderStatus: OrderStatusDto;
}